// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","text":"Button_text__N0g-B"};